var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    _vm._b(
      {
        staticClass: "modal-content",
        attrs: {
          title: `${
            _vm.modelType === "edit"
              ? "编辑"
              : _vm.modelType === "view"
              ? "查看"
              : "添加"
          }${_vm.title}`,
          width: 900,
          visible: _vm.visible,
          "ok-text": "保存",
          destroyOnClose: "",
        },
        on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
      },
      "a-modal",
      _vm.extraProps,
      false
    ),
    [
      [
        _c(
          "a-form-model",
          {
            ref: "ruleForm",
            attrs: {
              labelCol: _vm.labelCol,
              wrapperCol: _vm.wrapperCol,
              model: _vm.form,
              rules: _vm.rules,
            },
          },
          [
            _c(
              "a-form-model-item",
              { attrs: { label: "辅导时间", prop: "tutoringTime" } },
              [
                _c("a-date-picker", {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择日期", disabled: _vm.isView },
                  model: {
                    value: _vm.form.tutoringTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "tutoringTime", $$v)
                    },
                    expression: "form.tutoringTime",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "辅导类型", prop: "tutoringType" } },
              [
                _c("j-dict-select-tag", {
                  attrs: {
                    placeholder: "请选择辅导类型",
                    extraOptions: _vm.menuMaps.tutoringType,
                    disabled: _vm.isView,
                  },
                  model: {
                    value: _vm.form.tutoringType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "tutoringType", $$v)
                    },
                    expression: "form.tutoringType",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "辅导方法", prop: "tutoringMethod" } },
              [
                _c("j-dict-select-tag", {
                  attrs: {
                    placeholder: "请选择辅导方法",
                    dictCode: "tutoring_method",
                    disabled: _vm.isView,
                  },
                  model: {
                    value: _vm.form.tutoringMethod,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "tutoringMethod", $$v)
                    },
                    expression: "form.tutoringMethod",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "问题原因", prop: "reason" } },
              [
                _c("j-dict-select-tag", {
                  attrs: {
                    placeholder: "请选择问题原因",
                    mode: "multiple",
                    extraOptions: _vm.menuMaps.psychologyIssues,
                    disabled: _vm.isView,
                  },
                  model: {
                    value: _vm.form.reason,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "reason", $$v)
                    },
                    expression: "form.reason",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "下一步措施", prop: "nextIntervention" } },
              [
                _c("j-dict-select-tag", {
                  attrs: {
                    mode: "multiple",
                    placeholder: "请选择下一步措施",
                    extraOptions: _vm.menuMaps.nextIntervention,
                    disabled: _vm.isView,
                  },
                  model: {
                    value: _vm.form.nextIntervention,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "nextIntervention", $$v)
                    },
                    expression: "form.nextIntervention",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "效果反馈", prop: "effectFeedback" } },
              [
                _c("j-dict-select-tag", {
                  attrs: {
                    placeholder: "请选择效果反馈",
                    extraOptions: _vm.menuMaps.effectFeedback,
                    disabled: _vm.isView,
                  },
                  model: {
                    value: _vm.form.effectFeedback,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "effectFeedback", $$v)
                    },
                    expression: "form.effectFeedback",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "危机等级", prop: "crisisLevel" } },
              [
                _c("j-dict-select-tag", {
                  attrs: {
                    placeholder: "请选择危机等级",
                    extraOptions: _vm.menuMaps.careList,
                    disabled: _vm.isView,
                  },
                  model: {
                    value: _vm.form.crisisLevel,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "crisisLevel", $$v)
                    },
                    expression: "form.crisisLevel",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              {
                attrs: {
                  label: "以上信息是否反馈校领导",
                  prop: "feedbackFlag",
                  labelCol: { span: 5 },
                  wrapperCol: { span: 18 },
                },
              },
              [
                _c(
                  "a-radio-group",
                  {
                    attrs: { disabled: _vm.isView },
                    on: { change: _vm.handleFeedbackChange },
                    model: {
                      value: _vm.form.feedbackFlag,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "feedbackFlag", $$v)
                      },
                      expression: "form.feedbackFlag",
                    },
                  },
                  [
                    _c("a-radio", { attrs: { value: 1 } }, [_vm._v("是")]),
                    _c("a-radio", { attrs: { value: 0 } }, [_vm._v("否")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.form.feedbackFlag === 1
              ? _c(
                  "a-form-model-item",
                  { attrs: { label: "请选择校领导", prop: "leaderId" } },
                  [
                    _c("j-dict-select-tag", {
                      attrs: {
                        filterable: "",
                        placeholder: "请选择校领导",
                        mode: "multiple",
                        extraOptions: _vm.menuMaps.schoolLeaders,
                        disabled: _vm.isView,
                      },
                      model: {
                        value: _vm.form.leaderId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "leaderId", $$v)
                        },
                        expression: "form.leaderId",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "a-form-model-item",
              { attrs: { label: "辅导记录表" } },
              [
                !_vm.isView
                  ? _c(
                      "a-upload",
                      {
                        attrs: {
                          name: "file",
                          multiple: true,
                          headers: _vm.tokenHeader,
                          action: _vm.importExcelUrl,
                          "file-list": _vm.defaultFileList,
                        },
                        on: {
                          change: _vm.uploadFile,
                          preview: _vm.handlePreview,
                        },
                      },
                      [
                        _vm.defaultFileList.length < 3
                          ? _c("a-button", { attrs: { icon: "import" } }, [
                              _vm._v("上传文件"),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm.isView && _vm.form.tutorRecordUrl
                  ? _c(
                      "div",
                      { staticClass: "view-file-list" },
                      _vm._l(
                        (_vm.form.tutorRecordUrl || "")
                          .split(",")
                          .filter(Boolean),
                        function (url, index) {
                          return _c(
                            "span",
                            {
                              key: index,
                              staticClass: "view-file-item",
                              on: {
                                click: function ($event) {
                                  return _vm.handleFilePreview(url)
                                },
                              },
                            },
                            [
                              _c("a-icon", { attrs: { type: "paper-clip" } }),
                              _vm._v(
                                "\n            附件" +
                                  _vm._s(index + 1) +
                                  "\n          "
                              ),
                            ],
                            1
                          )
                        }
                      ),
                      0
                    )
                  : _c("span", [_vm._v("无")]),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "具体情况说明" } },
              [
                _c("a-textarea", {
                  attrs: {
                    placeholder: "请输入具体情况说明",
                    "auto-size": { minRows: 4, maxRows: 8 },
                    disabled: _vm.isView,
                    maxlength: 200,
                  },
                  model: {
                    value: _vm.form.specificInstructions,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "specificInstructions", $$v)
                    },
                    expression: "form.specificInstructions",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }